import type { InvitationPreview, VerifyResponse } from '@/api/types'

/**
 * Whether the accept/verify success screen has a bearer token to reveal (bug-221).
 *
 * A BILLING invitee has no zone and no MCP access, so the server issues no token and omits the
 * key; the screen must not render the one-time token panel, the MCP setup hint, or send them to
 * Setup.
 */
export function revealsToken(result: Pick<VerifyResponse, 'token' | 'role'>): boolean {
  return result.role !== 'BILLING' && typeof result.token === 'string' && result.token.length > 0
}

/** Where "Sign in to the console" lands: Setup for a token holder, the Plan page for BILLING. */
export function landingAfterVerify(result: Pick<VerifyResponse, 'token' | 'role'>): string {
  return revealsToken(result) ? '/app/setup' : '/app/plan'
}

/**
 * The name field's value: what the invitee typed once they have touched it, otherwise the name
 * the inviting ADMIN gave (bug-221), otherwise empty. `typed === undefined` means untouched, so
 * clearing the field on purpose stays cleared.
 */
export function nameFieldValue(typed: string | undefined, preview: InvitationPreview | undefined): string {
  if (typed !== undefined) return typed
  return preview?.invited === true && typeof preview.name === 'string' ? preview.name : ''
}
